﻿export class ERC20HelperABI
{
    public static GetABI():any
    {
        return [
	{
		"inputs": [
			{
				"internalType": "address[]",
				"name": "erc20Tokens_",
				"type": "address[]"
			}
		],
		"name": "getNames",
		"outputs": [
			{
				"internalType": "string[]",
				"name": "names_",
				"type": "string[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address[]",
				"name": "erc20Tokens_",
				"type": "address[]"
			}
		],
		"name": "getSymbols",
		"outputs": [
			{
				"internalType": "string[]",
				"name": "symbols_",
				"type": "string[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];
    }
}